import React, { CSSProperties } from 'react';
import { ButtonView } from '@vivli/shared/views';
import { emptyDataStyle } from '../awaiting-actions/cards/card-styles';
import { Color, Size } from '@vivli/shared/theme';

interface NoDataActionViewProps {
    mainDescription: string;
    buttonText?: string;
    buttonUrl?: string;
    showGoToButton?: boolean;
}

const mainDescriptionStyle: CSSProperties = {
    paddingTop: Size.PADDING * 3,
    fontSize: 22,
    fontWeight: Size.FontWeight.ExtraExtraBold,
    color: Color.TEXT_VERY_DARK_GRAY,
    textAlign: 'center',
};

export const NoDataActionView = ({ mainDescription, buttonText, buttonUrl, showGoToButton }: NoDataActionViewProps) => {
    const handleViewAllButtonClick = () => {
        window.open(buttonUrl, '_blank');
    };

    return (
        <div style={emptyDataStyle}>
            <div style={mainDescriptionStyle}>
                <div>{mainDescription}</div>
                {showGoToButton && buttonText && (
                    <div style={{ paddingTop: Size.PADDING * 2 }}>
                        <ButtonView title={buttonText} theme={'white-on-lightblue'} onClick={handleViewAllButtonClick}>
                            {buttonText}
                        </ButtonView>
                    </div>
                )}
            </div>
        </div>
    );
};
